import React, { Component } from 'react'
export default class Profile extends Component {
    render() {

        return (
            <div className="container">
                <p id="game"></p>
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./src/components/Profile.jsx